import React from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { VendorModalType } from '../../../pages/FinancialForensicsPage/FinancialForensics.types';
import { ClickAwayListener, Grid, Popper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useState } from 'react';
import {
  Add,
  Button,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

type AddVendorDropdownProps = {
  width?: string;
  setOpenVendorModal: React.Dispatch<React.SetStateAction<VendorModalType>>;
  setOpenStoplossModal: React.Dispatch<React.SetStateAction<VendorModalType>>;
  handleAddNewDocument: () => void;
};

const useStyles = makeStyles<{ width?: string }>()((_theme, { width }) => ({
  popup: {
    width: width ?? '170px',
    borderRadius: '4px',
    border: '1px solid' + patientAccessTheme.palette.grey[300],
    background: patientAccessTheme.palette.background.default,
    boxShadow: '0px 2px 4px 0px #0000000D',
    marginTop: '4px',
    zIndex: 500,
  },
  chips: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '12px',
    height: 'auto',
  },
}));

export const AddVendorDropdown: React.FC<AddVendorDropdownProps> = ({
  width,
  setOpenVendorModal,
  setOpenStoplossModal,
  handleAddNewDocument,
}) => {
  const { classes } = useStyles({ width });
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorElement);
  const id = open ? 'simple-popper' : undefined;

  const handleClickButton = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(anchorElement ? null : event.currentTarget);
  };

  const closePopper = () => setAnchorElement(null);

  const handleVendorClick = () => {
    setOpenVendorModal({ open: true, type: 'FEES', actionType: 'ADD' });
    closePopper();
  };

  const handleStopLossClick = () => {
    setOpenStoplossModal({ open: true, type: 'STOPLOSS', actionType: 'ADD' });
    closePopper();
  };

  const handleAddDocumentClick = () => {
    handleAddNewDocument();
    closePopper();
  };

  return (
    <>
      <Button
        label="Add"
        startIcon={<Add fill={patientAccessTheme.palette.primary[500]} />}
        variant="outlined"
        height="32px"
        onClick={handleClickButton}
      />
      <Popper
        id={id}
        open={open}
        anchorEl={anchorElement}
        placement="bottom-end"
        className={classes.popup}
      >
        <ClickAwayListener onClickAway={closePopper}>
          <Grid className={classes.chips}>
            <Button
              label="Add Vendor"
              startIcon={<Add fill={patientAccessTheme.palette.primary[500]} />}
              variant="text"
              height="32px"
              width="auto"
              onClick={handleVendorClick}
            />
            <Button
              label="Add Document"
              startIcon={<Add fill={patientAccessTheme.palette.primary[500]} />}
              variant="text"
              height="32px"
              width="auto"
              onClick={handleAddDocumentClick}
            />
            <Button
              label="Add Stop Loss"
              startIcon={<Add fill={patientAccessTheme.palette.primary[500]} />}
              variant="text"
              height="32px"
              width="auto"
              onClick={handleStopLossClick}
            />
          </Grid>
        </ClickAwayListener>
      </Popper>
    </>
  );
};
